import { INode } from "../types/INode"
import { Node } from "../types/Node"
import { Finder, IFinder } from "../finder/IFinder"
import { DateString } from "@/DateString";

class User {
    email: string = "";
    name:string =""
}

class Dzialanie {
    czynnosc: string =""
    data_utworzenia: Date|undefined = new Date()
    data_plan: Date|undefined = undefined
    data_zakonczenia: Date|undefined = undefined
    pracownik_odpowiedzialny:string|undefined=undefined;
    rola:string|undefined = undefined;
    koszt_pln:number=0
    komentarz: string="";
}

class Winni {
    pracownik_dh:               string|undefined=undefined;
    pracownik_przygotowalni:    string|undefined=undefined;
    kontrolujacy_w_przygotowalni:    string|undefined=undefined;
    kopista: string|undefined=undefined;
    mistrz_zmianowy_podczas_kopiowania: string|undefined=undefined;
    maszynista: string|undefined=undefined;
    mistrz_zmianowy_podczas_druku: string|undefined=undefined;
    konfekcjoner: string|undefined
}

export class Dict {


    role_pracowników:string[] =  ["PRACOWNIK DH",]
    static rodzaje:string[] = ["REKLAMACJA WEWNĘTRZNA", "REKLAMACJA ZEWNĘTRZNA", "NIEZGODNOŚĆ ZEWNĘTRZNA"] 
    etapy:string[] = ["WYJAŚNIENIE DZIAŁ PRODUKCJI", "REKLAMACJA ZEWNĘTRZNA", "NIEZGODNOŚĆ ZEWNĘTRZNA"] 
    static powody:string[] = ["Przesztancowanie","Zła kolorystyka","Zły zwój", "Wady etykiet IML","Niewłaściwy surowiec, lakier",
                        "Uszkodzenia mechaniczne etykiet, rolek, opakowań","Niezgodne teksty, znaki graficzne","Odklejanie się etykiet od produktu",
                       "Brak możliwości zadruku TTR","Nieodklejanie się etykiet od taśmy nośnej","Zła jakość druku","Wadliwa termo-czułość","Błąd w zleceniu produkcyjnym", "Inny powód"
                    ]
    
    static przyczyny:string[] = ["Błędny opis na karcie","Błąd w druku","Błąd w przygotowalni","Wadliwy surowiec","Wadliwe wykonanie formy","Niewłaściwe konfekcjonowanie"]

    static zwrot_etykiet:string[] = ["TAK", "NIE","W TRAKCIE USTALEŃ"]
    winni = new Winni;
    kategorie_bledu: string[] = ["KRYTYCZNY","ISTOTNY","MAŁO ISTOTNY"]
    odpowiedzialni :string[] = ["CZŁOWIEK","MASZYNA","METODA","SUROWIEC","INNE"]
    tak_nie:string[] = ["TAK","NIE"]
    
    czynnosci = ["PRZEWIJANIE","WYKLEJANIE","DODRUK","PONOWNY WYDRUK","INNE"]



}

export interface IReklamacja extends INode {
    type:string;
    version:number;
    _id:string|undefined
    parent_id:string
    _err:any;
    fnd:string;
    del:number;

     // zakł. dane podstawowe
    data_wprowadzenia:Date|undefined
    nadzorca_reklamacji:IFinder;
    idn:string;
    klient: IFinder;
    rodzaj_reklamacji:string;
    osoba_kontaktowa: IFinder;
    zlecenie:IFinder;

    ilosc_zlecenie:number;
    ilosc_reklamowana:number
    ilosc_wadliwych:number
    ilosc_wadliwych_uznana:number

    wartosc_1K:number
    wartosc_zlecenie:number
    wartosc_reklamowana:number
    wartosc_wadliwych:number
    wartosc_wadliwych_uznana:number

    koszt_transportu:number
    koszty_inne:number
    koszty_inne_opis:string;
    koszt_reklamacji:number;

    dodatkowe_zlecenia:string[];

    skierowana_do: IFinder;

    etap:string;
    
    // zakł. reklamacja
    powod_reklamacji:string;
    inny_powod_reklamacji:string;
    roszczenie_klienta:string;
    opis_reklamacji:string;
    
    // zakł. ocena DH
    dyrektor_DH:string
    wstepne_wyjasnienie_reklamacji:string;
    // winny dh

    // ocena Produkcja
    wyjasnienia_szefa_produkcji:string
    //winni

    
    // opis przyczyna niezgodności
    przyczyna:string
    inna_przyczyna:string
    opis:string

    wadliwy_surowiec:string
    dostawca_surowca:string;
    dzialania_korekcyjne: Dzialanie[]
    podjete_czynnosci: Dzialanie[]

    // ZAKLADKA KOSZTY/SPOSOB ROZWIĄZANIA
    
    faktura_korygujaca:string
    dodruk_zlecenie:string
   
    zwrot_etykiet:string;


}
  
export class Reklamacja implements IReklamacja {
    type:string="reklamacja";
    version:number=0;
    _id:string|undefined = undefined;
    parent_id:string=""
    idn:string =  "REKLAMACJA_"+DateString.toISOString()
    fnd:string=""
    del:number=0

     // zakł. dane podstawowe
     data_wprowadzenia:Date|undefined
     nadzorca_reklamacji=new Finder();
     klient: IFinder=new Finder();
     rodzaj_reklamacji:string="";

     osoba_kontaktowa:IFinder=new Finder();
     zlecenie:Finder=new Finder();

     ilosc_zlecenie:number=0;
     ilosc_reklamowana:number=0
     ilosc_wadliwych:number=0
     ilosc_wadliwych_uznana:number=0

     wartosc_1K:number=0;
     wartosc_zlecenie:number=0;
     wartosc_reklamowana:number=0
     wartosc_wadliwych:number=0
     wartosc_wadliwych_uznana:number=0
 
     dodatkowe_zlecenia:string[]=[]
 
     skierowana_do: Finder=new Finder();
 
     etap:string="";
     
     // zakł. reklamacja
     powod_reklamacji:string="";
     inny_powod_reklamacji:string="";
     roszczenie_klienta:string="";
     opis_reklamacji:string="";
     
     // zakł. ocena DH
     dyrektor_DH:string=""
     wstepne_wyjasnienie_reklamacji:string=""
     // winny dh
 
     // ocena Produkcja
     wyjasnienia_szefa_produkcji:string=""
     //winni
 
     
     // opis przyczyna niezgodności
     przyczyna:string=""
     inna_przyczyna:string=""
     opis:string=""
 
     wadliwy_surowiec:string=""
     dostawca_surowca:string="";
     dzialania_korekcyjne: Dzialanie[]=[]
     podjete_czynnosci: Dzialanie[]=[]
 
     // ZAKLADKA KOSZTY/SPOSOB ROZWIĄZANIA

     zwrot_etykiet:string="";
   
     koszt_transportu:number=0
     koszty_inne:number=0
     koszty_inne_opis:string=""
     koszt_reklamacji:number=0
     faktura_korygujaca:string=""
     dodruk_zlecenie:string=""
 
    _err:any={}


}

